import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './ErrorBoundary';
import { StateContextProvider } from './State';
import { fullpageloginRootId } from './constants';
import { ModelProvider } from './ModelProvider';

const container = document.getElementById(fullpageloginRootId);
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <ModelProvider>
                <StateContextProvider>
                    <App />
                </StateContextProvider>
            </ModelProvider>
        </ErrorBoundary>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
